import {
    ADD_FEED_CANCEL_MODEL_UPDATE,
    AUTOCOMPLETE_ERROR_RESPONSE,
    COMMUNITY_AWAITING_APPROVAL_LIST_ERROR_RESPONSE,
    COMMUNITY_CANCEL_ADDING_MEMBERS,
    COMMUNITY_CANCEL_MODEL_UPDATE,
    COMMUNITY_FOLLOWERS_LIST_ERROR_RESPONSE,
    COMMUNITY_INVITED_LIST_ERROR_RESPONSE,
    COMMUNITY_ITEM_ERROR_RESPONSE,
    COMMUNITY_ITEM_SAVE_RESPONSE,
    COMMUNITY_LIST_ERROR_RESPONSE,
    COMMUNITY_MANAGERS_LIST_ERROR_RESPONSE,
    COMMUNITY_MEMBERS_ADD_LIST_ERROR_RESPONSE,
    COMMUNITY_MEMBERS_LIST_ERROR_RESPONSE,
    DASHBOARD_INFO_ERROR_RESPONSE,
    DIMENSION_ITEM_ERROR_RESPONSE,
    DIMENSION_ITEM_SAVE_RESPONSE,
    DIMENSION_LIST_COUNT_ERROR_RESPONSE,
    DIMENSION_LIST_ERROR_RESPONSE,
    DIMENSION_WIZARD_ERROR_RESPONSE,
    EVIDENCE_ITEM_ERROR_RESPONSE,
    FEED_CANCEL_MODEL_UPDATE,
    INSIGHT_AREA_CANCEL_ADD_OWNERS_VIEWERS,
    INSIGHT_AREA_CANCEL_MODEL_UPDATE,
    INSIGHT_AREA_MAPPING_PREVIEW_ERROR_RESPONSE,
    KEY_ISSUE_CANCEL_ADD_OWNERS_VIEWERS,
    KEY_ISSUE_CANCEL_MODEL_UPDATE,
    KEY_ISSUE_MAPPING_PREVIEW_ERROR_RESPONSE,
    KNOWLEDGE_ANALYSE_ERROR_RESPONSE,
    KNOWLEDGE_ITEM_ERROR_RESPONSE,
    KNOWLEDGE_ITEM_SAVE_RESPONSE,
    KNOWLEDGE_LIST_ERROR_RESPONSE,
    PLACEHOLDER_ADD_ERROR_RESPONSE,
    PROJECT_LIST_ERROR_RESPONSE,
    SESSION_LIST_ERROR_RESPONSE,
    SOURCE_CANCEL_MODEL_UPDATE,
    SOURCE_ITEM_DELETE_ERROR_RESPONSE,
    SOURCE_ITEM_ERROR_RESPONSE,
    SOURCE_ITEM_SAVE_ERROR_RESPONSE,
    SOURCE_ITEM_SAVE_RESPONSE,
    SOURCE_LIST_ERROR_RESPONSE,
    STAKEHOLDER_CANCEL_MODEL_UPDATE,
    STAKEHOLDER_LIST_ERROR_RESPONSE,
    STUDIO_BRIEFING_EMAIL_CANCEL,
    STUDIO_BRIEFING_EMAIL_ERROR_RESPONSE,
    STUDIO_BRIEFING_REQUEST,
    STUDIO_CREATE_DIMENSION_CANCEL,
    STUDIO_CREATE_DIMENSION_SAVE_RESPONSE,
    STUDIO_DIMENSION_WIZARD_ERROR_RESPONSE,
    STUDIO_DOWNLOAD_IMAGE_REQUEST,
    STUDIO_EDIT_CANCEL_MODEL_UPDATE,
    STUDIO_ITEM_DELETE_ERROR_RESPONSE,
    STUDIO_ITEM_ERROR_RESPONSE,
    STUDIO_ITEM_SAVE_ERROR_RESPONSE,
    STUDIO_ITEM_SAVE_RESPONSE,
    STUDIO_LIST_ERROR_RESPONSE,
    TOPIC_ITEM_ERROR_RESPONSE,
    TOPIC_ITEM_SAVE_ERROR_RESPONSE,
    TOPIC_LIST_COUNT_ERROR_RESPONSE,
    TOPIC_LIST_ERROR_RESPONSE,
    USER_CANCEL_MODEL_UPDATE,
    USER_ITEM_ERROR_RESPONSE,
    USER_ITEM_SAVE_RESPONSE,
    USER_LIST_ERROR_RESPONSE
} from "../actions/action-types"
import { addAlert } from "../actions/alert-actions"
import {
    analysingErrorMessage,
    briefingGenerationMessage,
    cancelChangesMessage,
    defaultErrorMessage,
    deleteErrorMessage,
    imageGenerationMessage,
    saveErrorMessage,
    saveSuccessMessage
} from "../config/alert-message-definitions"
import { apiErrorReason } from "./default-epics/epic-utils"

export const errorMessageEpic = (action$, { getState }) =>
    action$
        .ofType(
            KNOWLEDGE_LIST_ERROR_RESPONSE,
            KNOWLEDGE_ITEM_ERROR_RESPONSE,
            DASHBOARD_INFO_ERROR_RESPONSE,
            SOURCE_ITEM_ERROR_RESPONSE,
            TOPIC_LIST_ERROR_RESPONSE,
            TOPIC_LIST_COUNT_ERROR_RESPONSE,
            TOPIC_ITEM_ERROR_RESPONSE,
            INSIGHT_AREA_MAPPING_PREVIEW_ERROR_RESPONSE,
            DIMENSION_LIST_ERROR_RESPONSE,
            DIMENSION_LIST_COUNT_ERROR_RESPONSE,
            DIMENSION_ITEM_ERROR_RESPONSE,
            DIMENSION_WIZARD_ERROR_RESPONSE,
            KEY_ISSUE_MAPPING_PREVIEW_ERROR_RESPONSE,
            STUDIO_LIST_ERROR_RESPONSE,
            STUDIO_ITEM_ERROR_RESPONSE,
            STUDIO_BRIEFING_EMAIL_ERROR_RESPONSE,
            STUDIO_DIMENSION_WIZARD_ERROR_RESPONSE,
            COMMUNITY_LIST_ERROR_RESPONSE,
            COMMUNITY_ITEM_ERROR_RESPONSE,
            COMMUNITY_MEMBERS_LIST_ERROR_RESPONSE,
            COMMUNITY_MEMBERS_ADD_LIST_ERROR_RESPONSE,
            COMMUNITY_MANAGERS_LIST_ERROR_RESPONSE,
            COMMUNITY_FOLLOWERS_LIST_ERROR_RESPONSE,
            COMMUNITY_INVITED_LIST_ERROR_RESPONSE,
            COMMUNITY_AWAITING_APPROVAL_LIST_ERROR_RESPONSE,
            USER_ITEM_ERROR_RESPONSE,
            STAKEHOLDER_LIST_ERROR_RESPONSE,
            SESSION_LIST_ERROR_RESPONSE,
            PROJECT_LIST_ERROR_RESPONSE,
            PLACEHOLDER_ADD_ERROR_RESPONSE,
            SOURCE_LIST_ERROR_RESPONSE,
            USER_LIST_ERROR_RESPONSE,
            AUTOCOMPLETE_ERROR_RESPONSE
        )
        .map(() => addAlert("error", defaultErrorMessage, "Error"))

// A source save the API rejected (4xx) says why, e.g. "Invalid link pattern: …" or "Source already exists: …".
// Anything else, such as a server error, keeps the "try again" message, since retrying may work.
export const sourceSaveErrorMessageEpic = (action$) =>
    action$
        .ofType(SOURCE_ITEM_SAVE_ERROR_RESPONSE)
        .map(({ error }) =>
            addAlert(
                "error",
                (error.status >= 400 &&
                    error.status < 500 &&
                    apiErrorReason(error)) ||
                    saveErrorMessage("source"),
                "Error"
            )
        )

export const saveErrorMessageEpic = (action$, { getState }) =>
    action$
        .ofType(TOPIC_ITEM_SAVE_ERROR_RESPONSE, STUDIO_ITEM_SAVE_ERROR_RESPONSE)
        .map(() => addAlert("error", saveErrorMessage(), "Error"))

export const deleteErrorMessageEpic = (action$, { getState }) =>
    action$
        .ofType(
            SOURCE_ITEM_DELETE_ERROR_RESPONSE,
            STUDIO_ITEM_DELETE_ERROR_RESPONSE
        )
        .map(() => addAlert("error", deleteErrorMessage(), "Error"))

export const analysingErrorMessageEpic = (action$, { getState }) =>
    action$
        .ofType(KNOWLEDGE_ANALYSE_ERROR_RESPONSE)
        .map(() =>
            addAlert("error", analysingErrorMessage("knowledge"), "Error")
        )

export const evidenceUrlParsingErrorMessageEpic = action$ =>
    action$
        .ofType(EVIDENCE_ITEM_ERROR_RESPONSE)
        .map(() =>
            addAlert("error", "The url you've provided is not valid", "Error")
        )

export const saveSuccessMessageEpic = action$ =>
    action$
        .ofType(
            KNOWLEDGE_ITEM_SAVE_RESPONSE,
            SOURCE_ITEM_SAVE_RESPONSE,
            DIMENSION_ITEM_SAVE_RESPONSE,
            STUDIO_ITEM_SAVE_RESPONSE,
            STUDIO_CREATE_DIMENSION_SAVE_RESPONSE,
            COMMUNITY_ITEM_SAVE_RESPONSE,
            USER_ITEM_SAVE_RESPONSE
        )
        .map(() => addAlert("success", saveSuccessMessage(), "Success"))

export const alertMessageEpic = action$ =>
    action$
        .ofType(
            FEED_CANCEL_MODEL_UPDATE,
            ADD_FEED_CANCEL_MODEL_UPDATE,
            SOURCE_CANCEL_MODEL_UPDATE,
            INSIGHT_AREA_CANCEL_MODEL_UPDATE,
            INSIGHT_AREA_CANCEL_ADD_OWNERS_VIEWERS,
            KEY_ISSUE_CANCEL_MODEL_UPDATE,
            KEY_ISSUE_CANCEL_ADD_OWNERS_VIEWERS,
            STUDIO_BRIEFING_EMAIL_CANCEL,
            STUDIO_CREATE_DIMENSION_CANCEL,
            STUDIO_EDIT_CANCEL_MODEL_UPDATE,
            COMMUNITY_CANCEL_MODEL_UPDATE,
            COMMUNITY_CANCEL_ADDING_MEMBERS,
            USER_CANCEL_MODEL_UPDATE,
            STAKEHOLDER_CANCEL_MODEL_UPDATE
        )
        .map(() => addAlert("info", cancelChangesMessage()))

export const studioBriefingEpic = action$ =>
    action$
        .ofType(STUDIO_BRIEFING_REQUEST)
        .map(() =>
            addAlert("info", briefingGenerationMessage, null, null, 6000)
        )

export const studioDownloadImageEpic = action$ =>
    action$
        .ofType(STUDIO_DOWNLOAD_IMAGE_REQUEST)
        .map(() => addAlert("info", imageGenerationMessage, null, null, 6000))
